import PropTypes from 'prop-types';

import { ReportsManagerStatuses } from './consts';

import styles from './RowStatus.module.scss';

export function RowStatus(props) {
  const status = ReportsManagerStatuses[props.status];
  if (!status) {
    return <span>Unknown</span>;
  }

  return (
    <span className={styles.wrapper}>
      <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2" cy="2.5" r="2" fill={status.color} />
      </svg>
      <label>{status.label}</label>
    </span>
  );
}

RowStatus.propTypes = {
  status: PropTypes.string.isRequired,
};
